/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Dashboard 2 PRO React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that contains other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 PRO React layouts
import Analytics from "layouts/dashboards/analytics";
import ProfileOverview from "layouts/pages/profile/profile-overview";
import Cards from "layouts/pages/cards";
import Categories from "layouts/pages/categories";
import Kanban from "layouts/applications/kanban";
import SignInBasic from "layouts/authentication/sign-in/basic";
import SignInCover from "layouts/authentication/sign-in/cover";
import SignInIllustration from "layouts/authentication/sign-in/illustration";
import SignUpCover from "layouts/authentication/sign-up/cover";
import GeeksterSignUpCover from 'layouts/authentication/geekster-sign-up/cover'
import ResetCover from "layouts/authentication/reset-password/cover";
import SignOut from "layouts/authentication/sign-out";

// @mui icons
import Icon from "@mui/material/Icon";
import EditCard from "layouts/pages/edit-card";
import SeeCard from "layouts/pages/see-card";
import SubCategories from "layouts/pages/sub-categories";
import PlayQuizzes from "layouts/pages/play-quizzes";
import SavedCards from "layouts/pages/saved-cards";
import ExerciseQuizzes from "layouts/pages/exercise-quizzes";
import NewsLetter from "layouts/pages/NewsLetter";
import UserDetails from "layouts/pages/admin/user-details";
import Prices from "layouts/pages/prices";
import SearchCards from "layouts/pages/SearchCards";
import { Complete } from "layouts/authentication/complete";
// import SearchCards from "layouts/pages/SearchCards";

// Images

const routes = [
  {
    isVisible: false,
    name: "NewsLetter",
    key: "nyhedsbrev",
    route: "/nyhedsbrev",
    component: <NewsLetter />,
  },
  {
    isVisible: false,
    name: "Kort",
    key: "kort",
    route: "/kort/:id",
    component: <PlayQuizzes />,
  },
  {
    isVisible: true,
    type: "collapse",
    name: "Min Profil",
    key: "profile",
    icon: <Icon fontSize="medium">person</Icon>,
    collapse: [
      {
        name: "Redigér profil",
        key: "profile-overview",
        route: "/profile-overview",
        component: <ProfileOverview />,
      },
      {
        name: "Log ud",
        key: "logout",
        route: "/authentication/sign-out",
        component: <SignOut />,
      },
    ],
  },
  { isVisible: true, isAdmin: true, type: "divider", key: "divider-0" },
  {
    isVisible: true,
    isAdmin: true,
    type: "collapse",
    name: "Dashboards",
    key: "dashboards",
    icon: <Icon fontSize="medium">dashboard</Icon>,
    collapse: [
      {
        isAdmin: true,
        name: "Analytics",
        key: "analytics",
        route: "/dashboards/analytics",
        component: <Analytics />,
      }
    ],
  },
  {
    key: 'price',
    isVisible: false,
    isAdmin: false,
    route: "/pris",
    component: <Prices />,
  },
  {
    key: 'user-details',
    isVisible: false,
    isAdmin: true,
    route: "/user/:id",
    component: <UserDetails />,
  },
  { isVisible: true, type: "divider", key: "divider-1" },
  { isVisible: true, type: "title", title: "Quizkort", key: "title-pages" },
  {
    isVisible: false,
    isClickable: false,
    name: "Mine cards",
    key: "my-cards",
    route: "/my-cards",
    component: <Cards />,
  },
  {
    isVisible: false,
    isClickable: false,
    name: "Edit Card",
    key: "edit-card",
    route: "/cards/my-cards/edit-card/:id",
    component: <EditCard />,
  },
  {
    isVisible: false,
    name: "See Card",
    key: "see-card",
    route: "/cards/my-cards/see-card/:id",
    component: <SeeCard />,
  },
  {
    isVisible: false,
    name: "Play Quizzes",
    key: "practice-quizzes",
    route: "/cards/practice-quizzes/:id",
    component: <ExerciseQuizzes />,
  }, {
    isVisible: false,
    name: "Quizkort",
    key: "cards",
    component: <Kanban />,
    route: "/cards",
  },
  {
    isVisible: true,
    type: "collapse",
    name: "Quizkort",
    key: "cards",
    component: <Kanban />,
    route: "/cards",
    icon: <Icon fontSize="medium">apps</Icon>,
    collapse: [

      {
        name: "Quizkortværktøj",
        key: "generator",
        route: "/cards/generator",
        component: <Kanban />,
      },
      {
        name: "Gemte kort",
        key: "saved-cards",
        route: "/cards/saved-cards",
        component: <SavedCards />,
      },
      {
        name: "Hovedkategori",
        key: "my-categories",
        route: "/cards/my-categories",
        component: <Categories />,
      },
      {
        name: "Quiz-kategori",
        key: "my-sub-categories",
        route: "/cards/my-sub-categories",
        component: <SubCategories />,
      },
      {
        name: "Kortspørgsmål",
        key: "my-cards",
        route: "/cards/my-cards",
        component: <Cards />,
      },
      {
        isAdmin: true,
        name: "Søg kort",
        key: "search-cards",
        route: "/cards/search-cards",
        component: <SearchCards />,
      }

    ],
  },
  {
    isVisible: false,
    type: "collapse",
    name: "Authentication",
    key: "authentication",
    icon: <Icon fontSize="medium">content_paste</Icon>,
    collapse: [
      {
        name: "Sign In",
        key: "sign-in",
        collapse: [
          {
            name: "Basic",
            key: "basic",
            route: "/authentication/sign-in/basic",
            component: <SignInBasic />,
          },
          {
            name: "Cover",
            key: "cover",
            route: "/authentication/sign-in",
            component: <SignInCover />,
          },
          {
            name: "Illustration",
            key: "homepage",
            route: "/",
            component: <SignInIllustration />,
          },
        ],
      },
      {
        name: "Sign Up",
        key: "sign-up",
        collapse: [
          {
            name: "Cover",
            key: "cover",
            route: "/authentication/sign-up",
            component: <SignUpCover />,
          },
        ],
      },
      {
        name: "Complete sign up with unilogin",
        key: "complete-sign-up",
        collapse: [
          {
            name: "Cover",
            key: "cover",
            route: "/authentication/complete",
            component: <Complete />,
          },
        ],
      },
      {
        name: "Geekster Sign Up",
        key: "geekster-sign-up",
        collapse: [
          {
            name: "Cover",
            key: "cover",
            route: "/authentication/geekster-sign-up",
            component: <GeeksterSignUpCover />,
          },
        ],
      },
      {
        name: "Reset Password",
        key: "reset-password",
        collapse: [
          {
            name: "Cover",
            key: "cover",
            route: "/authentication/reset-password/cover",
            component: <ResetCover />,
          },
        ],
      },
    ],
  }
];

export default routes;
